import { ROOMS_ENDPOINTS } from "../../config/apiConfig";
import { getAuthToken } from "../../utils/apiUtils";

/**
 * Room Resource Service
 * Handles resource library CRUD operations for papers, links, notes, code, etc.
 */

/**
 * Get resources list
 */
export async function getResources(roomId, filters = {}) {
  try {
    const token = getAuthToken();
    const params = new URLSearchParams({
      page: filters.page || "1",
      limit: filters.limit || "20",
      ...(filters.resourceType && { resourceType: filters.resourceType }),
      ...(filters.folder && { folder: filters.folder }),
      ...(filters.pinnedOnly && { pinnedOnly: "true" }),
    });

    const response = await fetch(
      `${ROOMS_ENDPOINTS.RESOURCES.LIST(roomId)}?${params}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    const data = await response.json();
    return data;
  } catch (error) {
throw error;
  }
}

/**
 * Get single resource details
 */
export async function getResourceDetails(roomId, resourceId) {
  try {
    const token = getAuthToken();
    const response = await fetch(
      ROOMS_ENDPOINTS.RESOURCES.DETAIL(roomId, resourceId),
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    const data = await response.json();
    return data;
  } catch (error) {
throw error;
  }
}

/**
 * Create a new resource
 */
export async function createResource(roomId, resourceData) {
  try {
    const token = getAuthToken();
    const response = await fetch(ROOMS_ENDPOINTS.RESOURCES.CREATE(roomId), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(resourceData),
    });

    const data = await response.json();
    return data;
  } catch (error) {
throw error;
  }
}

/**
 * Update a resource
 */
export async function updateResource(roomId, resourceId, updates) {
  try {
    const token = getAuthToken();
    const response = await fetch(
      ROOMS_ENDPOINTS.RESOURCES.UPDATE(roomId, resourceId),
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(updates),
      }
    );

    const data = await response.json();
    return data;
  } catch (error) {
throw error;
  }
}

/**
 * Delete a resource
 */
export async function deleteResource(roomId, resourceId) {
  try {
    const token = getAuthToken();
    const response = await fetch(
      ROOMS_ENDPOINTS.RESOURCES.DELETE(roomId, resourceId),
      {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    const data = await response.json();
    return data;
  } catch (error) {
throw error;
  }
}

/**
 * Get folders list
 */
export async function getFolders(roomId) {
  try {
    const token = getAuthToken();
    const response = await fetch(ROOMS_ENDPOINTS.RESOURCES.FOLDERS(roomId), {
      headers: { Authorization: `Bearer ${token}` },
    });

    const data = await response.json();
    return data;
  } catch (error) {
throw error;
  }
}

/**
 * Toggle pin on resource
 */
export async function togglePinResource(roomId, resourceId, isPinned) {
  try {
    return await updateResource(roomId, resourceId, { isPinned });
  } catch (error) {
throw error;
  }
}

/**
 * Add comment to resource
 */
export async function addResourceComment(roomId, resourceId, content) {
  try {
    const token = getAuthToken();
    const response = await fetch(
      `${ROOMS_ENDPOINTS.RESOURCES.DETAIL(roomId, resourceId)}/comments`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ content }),
      }
    );

    const data = await response.json();
    return data;
  } catch (error) {
throw error;
  }
}

/**
 * Search resources
 */
export async function searchResources(roomId, query, limit = 20) {
  try {
    const token = getAuthToken();
    const response = await fetch(
      `${ROOMS_ENDPOINTS.RESOURCES.LIST(roomId)}/search?q=${encodeURIComponent(
        query
      )}&limit=${limit}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    const data = await response.json();
    return data;
  } catch (error) {
throw error;
  }
}

export default {
  getResources,
  getResourceDetails,
  createResource,
  updateResource,
  deleteResource,
  getFolders,
  togglePinResource,
  addResourceComment,
  searchResources,
};

